export default {
    lang: {
        name: 'Play Location'
    }
}